import ToggleContentLoader from 'static-components/src/toggle-content';
import ScrollPositionRight from 'static-components/src/scroll-position-right';
import initializeTippy from "./tippyEntry";
var initializeUtilities = function () {
    new ToggleContentLoader();
    new ScrollPositionRight();
    initializeTippy();
};
export default initializeUtilities;
